import React from "react";
import { Link } from "react-router-dom";

function HelpLayout({ title, backTo = "/", backLabel = "Back to JokeLab", children }) {
  return (
    <div
      className="min-h-screen w-full flex flex-col items-center"
      style={{ backgroundColor: "#e6dcc6" }}
    >
      <div
        className="w-full max-w-3xl flex flex-col"
        style={{ backgroundColor: "#f7f2e3", minHeight: "100vh" }}
      >
        <div className="w-full flex items-center justify-between px-4 py-4">
          <h1 className="text-2xl font-bold text-green-900">{title}</h1>
          <Link to={backTo} className="text-sm font-semibold text-blue-600 hover:underline">
            &larr; {backLabel}
          </Link>
        </div>
        <div className="px-4 pb-10">{children}</div>
      </div>
    </div>
  );
}

export default HelpLayout;
